import { gql } from '@apollo/client';

export const DISCONNECT_CAREGIVER = gql /* GraphQL */ `
	mutation DisconnectCareGiver($careGiverUuid: String!, $careReceiverUuid: String!) {
		disconnectCareGiver(careGiverUuid: $careGiverUuid, careReceiverUuid: $careReceiverUuid)
	}
`;
